import React from 'react'

export function Chevron(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg width="10" height="6" viewBox="0 0 10 6" fill="black" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.39802 5.94478L9.9767 1.36609L8.90021 0.288086L5.39802 3.79257L1.89658 0.288086L0.819336 1.36533L5.39802 5.94478Z"/>
  </svg>
}
